import React, { useEffect, useState } from 'react';
import * as S from './styles';
import { withRouter } from 'react-router-dom';
import { Container, Grid, MenuItem, InputAdornment } from '@material-ui/core';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import CarouselComponent from '../Carousel';
import PlaceIcon from '@material-ui/icons/Place';
import CheckIcon from '@material-ui/icons/Check';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { addDays, format, parseISO } from 'date-fns';
import { useGlobal } from '../../contexts/globalContext';
import { useHistory } from 'react-router-dom';
import { addFeeByDestinoFerias } from '../../utils/addFeeByDestinoFerias';
import FormInput from '../FormInput';
import InputCalendar from '../InputDate';
import CalendarPrimary from '../../assets/icons/CalendarPrimary.svg';
import ThemeButton from '../ThemeButton';
import RegisterModal from '../RegisterModal';
import { getSessionStorage } from '../../utils/getSessionStorage';
import VitrineRepository from '../../repositories/vitrineRepository';

// renderiza um texto multi-linha como topicos (bullets); cai pra 1 item se vier linha unica
const renderBullets = (text) => {
	const items = String(text || '')
		.split(/\r?\n/)
		.map((t) => t.trim())
		.filter(Boolean);
	if (items.length === 0) return null;
	return (
		<S.BulletList>
			{items.map((item, index) => (
				<li key={index}>{item}</li>
			))}
		</S.BulletList>
	);
};

const formatDateBR = (iso) => {
	try {
		return format(parseISO(iso), 'dd/MM/yyyy');
	} catch (e) {
		return iso;
	}
};

function ExperienceDetailsComponent({ experience, images, buscaAtual }) {
	const { user, signed, showAlert } = useGlobal();
	const [adults, setAdults] = useState(1);
	const initialState = {
		datas: '',
	};
	const [state, setState] = useState(initialState);
	// US-28: indice da data selecionada no dropdown (exclusivos de data fixa)
	const [selectedDateIdx, setSelectedDateIdx] = useState('');
	const [isOpenRegisterModal, setIsOpenRegisterModal] = useState(false);
	const [shortenCoinAlias, setShortenCoinAlias] = useState('Pts');
	const handleRegisterModal = () => setIsOpenRegisterModal((prev) => !prev);
	let history = useHistory();

	useEffect(() => {
		setShortenCoinAlias(
			user?.campaign?.campaignConfig?.shortenCoinAlias || 'Pts'
		);
	}, [user?.campaign?.campaignConfig?.shortenCoinAlias]);

	// converte o preco para pontos do usuario (espelha ExpSubDetail.getValuesByUser)
	const getValuesByUser = (val) => {
		let value = signed
			? val * user.catalog.catalogCurrencyConfig.conversionRate
			: val;
		if (user.campaign) value = addFeeByDestinoFerias(value, buscaAtual);
		return signed ? Math.ceil(Math.round(value)) : value;
	};

	const showInPoints =
		signed && !user?.guest && !user?.campaign?.disablePointActivity;

	const dates = experience?.experienceDates || [];
	const advanceDays = user?.campaign?.advanceDaysExperience || 0;
	const isPastDate = (iso) => {
		if (!iso) return false;
		try {
			return addDays(new Date(iso), advanceDays) <= new Date();
		} catch (e) {
			return false;
		}
	};
	const isDateUnavailable = (d) =>
		(d?.qtAvailable != null && d.qtAvailable <= 0) || isPastDate(d?.date);

	const selectedFixedDate =
		selectedDateIdx !== '' ? dates[selectedDateIdx] : null;

	// estoque exibido no card lateral (so para data fixa)
	const estoqueValue = experience?.continuous
		? null
		: selectedFixedDate?.qtAvailable;

	/* Demanda 231 parte 3 — liberacao programada de venda.
	   A experiencia pode estar visivel na busca antes de a compra abrir. Enquanto
	   nao chegar a data/hora configurada, mostramos o contador e travamos a
	   selecao de data e o botao de confirmar.

	   O relogio de referencia e o do servidor (RNF secao 20): o backend devolve
	   serverTime junto do detalhe e guardamos o desvio para o relogio do
	   dispositivo do cliente nao adiantar nem atrasar a liberacao. */
	const saleStartAt = experience?.isScheduled && experience?.scheduledSaleStartAt
		? new Date(experience.scheduledSaleStartAt)
		: null;

	const [serverOffset, setServerOffset] = useState(() => {
		try {
			const stored = getSessionStorage('@experience-details');
			return stored?.serverTime
				? new Date(stored.serverTime).getTime() - Date.now()
				: null;
		} catch (e) {
			return null;
		}
	});

	/* Quando a experiencia chega pelo banner da Vitrine o serverTime ja veio
	   junto. Quando chega pelo resultado de busca, nao — e a listagem nao
	   devolve hora. Nesse caso buscamos uma vez, e so para experiencia
	   programada, para nao pagar request em quem nao precisa. */
	useEffect(() => {
		if (serverOffset !== null) return;
		if (!experience?.isScheduled || !experience?.id) {
			setServerOffset(0);
			return;
		}
		new VitrineRepository()
			.getExperienceById(experience.id)
			.then((res) => {
				const serverTime = res?.data?.serverTime;
				setServerOffset(
					serverTime ? new Date(serverTime).getTime() - Date.now() : 0
				);
			})
			.catch(() => setServerOffset(0));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [experience?.id, experience?.isScheduled]);

	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		if (!saleStartAt) return undefined;
		// atualizacao por minuto e suficiente (RNF secao 20)
		const timer = setInterval(() => setNow(Date.now()), 60 * 1000);
		return () => clearInterval(timer);
	}, [saleStartAt && saleStartAt.getTime()]);

	/* Enquanto o offset nao resolveu, assume 0 so para exibir algo coerente;
	   o saleLocked abaixo mantem a venda travada nesse intervalo, que e o lado
	   seguro de errar numa venda com hora marcada. */
	const msUntilSale = saleStartAt
		? saleStartAt.getTime() - (now + (serverOffset || 0))
		: 0;
	const saleLocked = saleStartAt ? msUntilSale > 0 || serverOffset === null : false;

	const countdown = (() => {
		if (!saleLocked) return null;
		const totalMinutes = Math.floor(msUntilSale / 60000);
		return {
			days: Math.floor(totalMinutes / (60 * 24)),
			hours: Math.floor((totalMinutes % (60 * 24)) / 60),
			minutes: totalMinutes % 60,
		};
	})();

	const confirmDisabled = saleLocked
		? true
		: experience?.continuous
		? !state?.experienceDate?.dataIda
		: !selectedFixedDate || isDateUnavailable(selectedFixedDate);

	// monta o experienceDate selecionado (perene = calendario; data fixa = dropdown)
	const buildSelectedExperienceDate = () => {
		if (experience?.continuous) {
			if (!state?.experienceDate?.dataIda) return null;
			const dataIdaArr = state.experienceDate.dataIda.split('/');
			const isoDate = `${dataIdaArr[2]}-${dataIdaArr[1]}-${dataIdaArr[0]}`;
			return {
				date: isoDate,
				experienceId: experience.id,
				id: null,
				qtAvailable: 999,
				qtTotal: 999,
				time: null,
			};
		}
		return selectedFixedDate || null;
	};

	const onSubmit = () => {
		if (adults <= 0) {
			return showAlert('error', 'Quantidade de ingressos deve ser maior que 0.');
		}

		const experienceDate = buildSelectedExperienceDate();
		if (!experienceDate) {
			return showAlert('error', 'Selecione uma data para sua experiência.');
		}

		const qtRequested = parseInt(adults * (experience?.qtParticipants || 1));
		if (
			experienceDate?.qtAvailable != null &&
			qtRequested > experienceDate.qtAvailable
		) {
			return showAlert(
				'error',
				`Quantidade indisponível. Apenas ${experienceDate.qtAvailable} ${
					experienceDate.qtAvailable === 1
						? 'ingresso disponível'
						: 'ingressos disponíveis'
				} para esta data.`
			);
		}

		sessionStorage.setItem(
			'@ExperienceSelected',
			JSON.stringify({
				experienceDate: experienceDate,
				experience: experience,
				// guarda contra qtParticipants nulo (exclusivos cadastrados sem o campo)
				adults: qtRequested,
				childs: null,
			})
		);

		if (user?.guest || user?.travelVoucher) {
			return handleRegisterModal();
		}
		history.push('/busca/resumo');
	};

	const links = experience?.links || [];

	return (
		<S.Wrapper>
			<Container>
				{/* US-26: hero grande com overlay de titulo/localizacao + badge */}
				<S.Hero>
					<S.HeroBack onClick={() => history.goBack()} aria-label='Voltar'>
						<ArrowBackIcon fontSize='small' />
					</S.HeroBack>
					<S.CarouselContainer>
						<CarouselComponent buscaAtual={buscaAtual} images={images} />
					</S.CarouselContainer>
					<S.HeroOverlay>
							<S.HeroBadge>Experiência Exclusiva</S.HeroBadge>
						<S.HeroTitle>{experience?.name}</S.HeroTitle>
						{experience?.localization && (
							<S.HeroLocation>
								<PlaceIcon fontSize='small' />
								{experience?.localization}
							</S.HeroLocation>
						)}
					</S.HeroOverlay>
				</S.Hero>

				<Grid container spacing={4}>
					{/* US-27: coluna esquerda com conteudo em secoes */}
					<Grid item xs={12} md={12} lg={8}>
						<S.Section>
							<S.Title3>Descrição Geral</S.Title3>
							<S.Descricao>{experience?.description}</S.Descricao>
						</S.Section>

						{experience?.whatToExpect && (
							<S.Section>
								<S.Title3>O que esperar?</S.Title3>
								<S.Descricao>{experience?.whatToExpect}</S.Descricao>
							</S.Section>
						)}

						{/* Inclusos / Nao inclusos em duas colunas, como topicos */}
						<S.Section>
							<Grid container spacing={2}>
								{experience?.whatIsIncluded && (
									<Grid item xs={12} sm={6}>
										<S.Title3>O que está incluso</S.Title3>
										{renderBullets(experience.whatIsIncluded)}
									</Grid>
								)}
								{experience?.whatIsNotIncluded && (
									<Grid item xs={12} sm={6}>
										<S.Title3>O que NÃO está incluso</S.Title3>
										{renderBullets(experience.whatIsNotIncluded)}
									</Grid>
								)}
							</Grid>
						</S.Section>

						{experience?.importantInfo && (
							<S.Section>
								<S.Title3>Informações Importantes</S.Title3>
								<S.Descricao>{experience.importantInfo}</S.Descricao>
							</S.Section>
						)}

						{/* US-28: politicas de cancelamento em secao destacada */}
						{(experience?.cancellationPolicy || experience?.freeCancel) && (
							<S.PolicyBox>
								<S.Title3>Políticas de cancelamento</S.Title3>
								{experience?.freeCancel && (
									<span className='free'>
										<CheckIcon fontSize='small' /> Cancelamento grátis
									</span>
								)}
								{experience?.cancellationPolicy && (
									<S.Descricao>{experience.cancellationPolicy}</S.Descricao>
								)}
							</S.PolicyBox>
						)}

						{/* US-29: links adicionais como botoes (abrem em nova aba) */}
						{links.length > 0 && (
							<S.Section>
								<S.Title3>Links Adicionais</S.Title3>
								<S.LinksRow>
									{links.map((link, index) => (
										<a
											key={link.id || index}
											href={link.url}
											target='_blank'
											rel='noopener noreferrer'
											className='link-button'
										>
											<OpenInNewIcon fontSize='small' />
											{link.label || link.url}
										</a>
									))}
								</S.LinksRow>
							</S.Section>
						)}
					</Grid>

					{/* US-28: sidebar sticky com preco, data (dropdown), qtd, estoque e Confirmar Reserva */}
					<Grid item xs={12} md={12} lg={4}>
						<S.Sidebar>
							{/* US-28: preco "A PARTIR DE pts X /pessoa" (Figma) */}
							<S.PriceBlock>
								<span className='from-label'>A PARTIR DE</span>
								<div className='price'>
									{showInPoints ? (
										<span className='value'>
											pts {getValuesByUser(experience?.price)}
										</span>
									) : (
										<span className='value'>
											{Number(getValuesByUser(experience?.price) || 0).toLocaleString('pt-BR', {
												style: 'currency',
												currency: 'BRL',
											})}
										</span>
									)}
									<span className='per'>/pacote</span>
								</div>
							</S.PriceBlock>

							{/* parte 3 — contador regressivo ate a liberacao da venda */}
							{saleLocked && countdown && (
								<S.SaleCountdown>
									<span className='countdown-label'>Vendas abrem em</span>
									<div className='countdown-value'>
										<span>{countdown.days}d</span>
										<span>{countdown.hours}h</span>
										<span>{countdown.minutes}min</span>
									</div>
								</S.SaleCountdown>
							)}

							{/* selecao de data: dropdown (data fixa) ou calendario (perene) */}
							<S.DateField>
								<span className='field-label'>Selecione a data desejada</span>
								{experience?.continuous ? (
									<InputCalendar
										reverseColor={true}
										icon={CalendarPrimary}
										disabled={saleLocked}
										value={state?.experienceDate?.dataIda}
										onChange={(e) => setState({ ...state, experienceDate: e })}
										minStartDays={advanceDays}
										staticStartDate={
											experience?.startDate
												? new Date(experience.startDate)
												: undefined
										}
										staticEndDate={
											experience?.endDate
												? new Date(experience.endDate)
												: undefined
										}
									/>
								) : (
									<FormInput
										disabled={saleLocked}
										select
										value={selectedDateIdx}
										onChange={(e) => setSelectedDateIdx(e.target.value)}
										SelectProps={{ displayEmpty: true }}
									InputProps={{
										startAdornment: (
											<InputAdornment position='start'>
												<EventOutlinedIcon fontSize='small' />
											</InputAdornment>
										),
									}}
										InputLabelProps={{ shrink: false }}
									>
										<MenuItem value='' disabled>
											{saleLocked
												? 'Vendas ainda não liberadas'
												: dates.length
												? 'Selecione...'
												: 'Nenhuma data disponível'}
										</MenuItem>
										{dates.map((d, index) => {
											const unavailable = saleLocked || isDateUnavailable(d);
											return (
												<MenuItem key={index} value={index} disabled={unavailable}>
													{formatDateBR(d.date)}
													{d?.qtAvailable != null
														? ` — ${
																d.qtAvailable <= 0
																	? 'Esgotado'
																	: `${d.qtAvailable} disp.`
														  }`
														: ''}
												</MenuItem>
											);
										})}
									</FormInput>
								)}
							</S.DateField>

							{/* US-28: Qtde Pessoas | Estoque (caixas com icone + valor, Figma) */}
							<S.MetaRow>
								<div className='meta'>
									<span className='meta-label'>Quantidade</span>
									<div className='meta-value'>
										<PeopleAltOutlinedIcon fontSize='small' />
										<input
											type='number'
											min='1'
											value={adults}
											onChange={(e) =>
												e.target.value >= 0 && setAdults(e.target.value)
											}
										/>
									</div>
								</div>
								<div className='meta'>
									<span className='meta-label'>Estoque</span>
									<div
										className={`meta-value estoque ${
											estoqueValue != null && estoqueValue <= 0 ? 'soldout' : ''
										}`}
									>
										<ConfirmationNumberOutlinedIcon fontSize='small' />
										<span>
											{estoqueValue == null
												? '—'
												: estoqueValue <= 0
												? 'Esgotado'
												: `${estoqueValue} ${
														estoqueValue === 1 ? 'Vaga' : 'Vagas'
												  }`}
										</span>
									</div>
								</div>
							</S.MetaRow>

							<ThemeButton
								onClick={() => onSubmit()}
								className='confirm-reservation'
								disabled={confirmDisabled}
							>
								Confirmar Reserva <ArrowForwardIcon fontSize='small' />
							</ThemeButton>
							<S.Disclaimer>
								Ao clicar em confirmar, você será direcionado para o checkout
								seguro.
							</S.Disclaimer>

							</S.Sidebar>

						{/* US-28: caixa separada "Compra 100% Segura" (Figma) */}
						<S.SecureBadge>
							<VerifiedUserOutlinedIcon fontSize='small' />
							<strong>Compra 100% Segura</strong>
						</S.SecureBadge>
					</Grid>
				</Grid>
			</Container>
			<RegisterModal
				open={isOpenRegisterModal}
				onClose={handleRegisterModal}
				travelVoucherUser={user?.travelVoucher}
			/>
		</S.Wrapper>
	);
}

export default withRouter(ExperienceDetailsComponent);
